import { loadBalancingGroupActions } from './reducers';

export const {
  getCurrentLoadBalancingGroupAction,
  setCurrentLoadBalancingGroupAction,
  setLoadBalancingGroupErrorAction,
  clearCurrentLoadBalancingGroupAction,
} = loadBalancingGroupActions;
